import React from 'react';

import { useSharedPluginState } from '@atlaskit/editor-common/hooks';

import { toggleReadingAidsPopup } from '../../pm-plugins/ai-definitions/commands';

import { type Props } from './types';

export const DefineModal = (props: Props) => {
	const { ReadingAidsPopup, editorView } = props;
	const { aiDefinitionsState } = useSharedPluginState(props.api, ['aiDefinitions']);

	if (editorView && ReadingAidsPopup && aiDefinitionsState?.isReadingAidsPopupOpen) {
		return (
			// @ts-ignore TODO: Resolve once all type changes settle
			<ReadingAidsPopup
				{...aiDefinitionsState.readingAidsPopupProps}
				onClose={() => {
					const { state, dispatch } = editorView;
					toggleReadingAidsPopup({ open: false })(state, dispatch);
				}}
			/>
		);
	}

	return null;
};
